import produce from 'immer';

import {
  NON_PERSISTED_GQL_FIELDS_BY_CHART_TYPE,
  NON_PERSISTED_GQL_FIELDS_FOR_CHART_VIEW_BY_CHART_TYPE,
} from 'analysis-tool/charting/AnalysisChartingConstants';
import {
  AnalysisChartVisualizationConfig,
  AnalysisChartViewConfig,
} from 'analysis-tool/charting/AnalysisChartingTypes';
import {PARAMETERS_TYPENAME_TO_VISUALIZATION_TYPE} from 'insights/analytics-visualizations/AnalyticsVisualizationConstants';
import {
  VisualizationConfig,
  VisualizationType,
} from 'insights/universal-blocks/SharedUniversalBlockViewTypes';

/**
 * Transform a visualization config from the gql shape to match the visualization step config shape
 */
export default function getPersistedVisualizationConfig(
  visualizationConfig: VisualizationConfig
): AnalysisChartVisualizationConfig {
  const {__typename, ...remainingParameters} = visualizationConfig.parameters;
  const visualizationType = PARAMETERS_TYPENAME_TO_VISUALIZATION_TYPE[__typename];

  const parameters = produce(remainingParameters, (draftParameters) => {
    for (const field of NON_PERSISTED_GQL_FIELDS_BY_CHART_TYPE[visualizationType]) {
      if (draftParameters.hasOwnProperty(field)) {
        // @ts-expect-error
        delete draftParameters[field];
      }
    }
  });

  return {
    type: visualizationType,
    parameters,
  } as AnalysisChartVisualizationConfig;
}

const ANALYSIS_CHART_VIEW_EXCLUSIVE_PARAMETERS_TO_DEFAULTS = {
  tryConvertStrings: null,
};

/**
 * Transform a visualization config from the gql shape to match the chart view step config shape
 */
export function getPersistedChartViewConfig(
  visualizationConfig: VisualizationConfig
): AnalysisChartViewConfig {
  const {__typename, ...remainingParameters} = visualizationConfig.parameters;
  const visualizationType = PARAMETERS_TYPENAME_TO_VISUALIZATION_TYPE[__typename];

  const parameters = produce(remainingParameters, (draftParameters) => {
    for (const field of NON_PERSISTED_GQL_FIELDS_FOR_CHART_VIEW_BY_CHART_TYPE[visualizationType]) {
      if (draftParameters.hasOwnProperty(field)) {
        // @ts-expect-error
        delete draftParameters[field];
      }
    }
    Object.assign(draftParameters, ANALYSIS_CHART_VIEW_EXCLUSIVE_PARAMETERS_TO_DEFAULTS);
    if (visualizationType === VisualizationType.SCATTER_PLOT) {
      // @ts-expect-error
      draftParameters.seriesColorConfigs = null;
      // @ts-expect-error
      draftParameters.seriesShapeConfigs = null;
    }
  });

  return {
    type: visualizationType,
    parameters,
  } as AnalysisChartViewConfig;
}
